import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"
import {Client} from "types/Client"
import {PAGINATION_LIMITS} from "../../constants/constants"

type ReturnedType = {
    status: "success"
    data: {
        content: Client[]
        id: number
        create_at: string
        target_date: string
        page_number: number
        page_size: number
        total_elements: number
    }
}

type ClientsRequestParams = {
    page: number
    size: number
}

export const fetchClients = createAsyncThunk<ReturnedType, ClientsRequestParams, AppThunkProps>(
    "client/fetch",
    async ({page = 1, size = PAGINATION_LIMITS.TWENTY}, {signal}) => {
        return api.post<ReturnedType>("/applications/customer/list", {page, size}, {signal})
    }
)
